module.exports = __webpack_public_path__ + "4f744e8239d2552ad4ddf0b89b75a046.svg";